import angular from 'angular';

angular.module('cloudX').directive('cxRecentRelationsBar', [
  function() {
    return {
      restrict: 'E', //replace: true,
      template: require('./recentRelationsBar.html'),
      scope: true,

      controller: [
        '$scope',
        'dataCache',
        'relBindSvc',
        'recentRelationsSvc',
        function($scope, dataCache, relBindSvc, recentRelationsSvc) {
          $scope.recentRelationsSvc = recentRelationsSvc;
          $scope.open = relBindSvc.open;
        },
      ],
    };
  },
]);
